/* eslint-disable camelcase */
import { LocationMapper } from '@nx-smartmonkey/shared/domain';
import { Organization } from '../../domain/organization/Organization';
import { OrganizationDTO } from '../../domain/organization/OrganizationDTO';
import { OrganizationRepositoryDTO } from '../../domain/organization/OrganizationRepositoryDTO';
import { SubscriptionMapper } from '../subscription/SubscriptionMapper';

export class OrganizationMapper {
  static toDomain(props: OrganizationDTO): Organization {
    const {
      id,
      label,
      active,
      country,
      owner_id,
      avatar_url,
      default_project_id,
      location,
      subscription,
      num_of_vehicles,
      goal,
      section,
      created_by,
      created_at,
      updated_at,
      deleted_at,
    } = props;

    const locationDomain = location ? LocationMapper.toDomain(location) : undefined;

    return Organization.create(
      {
        label,
        active,
        country,
        owner_id: owner_id,
        avatar_url: avatar_url,
        default_project_id: default_project_id,
        location: locationDomain,
        subscription: SubscriptionMapper.toDomain(subscription),
        num_of_vehicles: num_of_vehicles,
        goal,
        section,
        created_by: created_by,
        created_at: created_at,
        updated_at: updated_at,
        deleted_at: deleted_at,
      },
      id
    );
  }

  static toRepository(organization: Organization): OrganizationRepositoryDTO {
    const { label, country, num_of_vehicles, goal, section, default_project_id, location, active } = organization.props;

    const locationRepository = location ? LocationMapper.toDTO(location) : undefined;

    return {
      label,
      country,
      num_of_vehicles,
      goal,
      section,
      default_project_id,
      location: locationRepository,
      active,
    };
  }
}
